define('drops/drawings/task/task',['jquery', 'drops/drawings/businessprocessElement'], function ($, BusinessProcessElement) {
    'use strict';
    
    var defaults = {
        data: {
            text: 'New Task',
            size: { x: 100, y: 40 },
            linkToApplication: false
        }
    };

    function Task(options) {
        BusinessProcessElement.call(this, $('<div/>'), defaults, options);
        
        this.$text = this.createTextElement();

        this.$element
	        .addClass('boxToBorderSize')
            .addClass('bp-element')
            .addClass('bp-task')
            .append(this.$text);
    };

    BusinessProcessElement.extend(Task, BusinessProcessElement);

    Task.typeName = 'Task';

    Task.prototype.createTextElement = function () {
        return $('<div/>')
            .text(this.data.text)
            .css({
                height: '100%'
            });
    };

    Task.prototype.preRender = function () {
        if (!this.editable && this.data.entityId) {
            var self = this;
            this.$element
                .css('cursor', 'pointer')
                .on('click', function () {
                    self.triggerEvent('drawingClicked', self.data.entityId);
                });
        }

        this.applyPosition();
    };

    return Task;
});
